import { SnoozeAlarm } from '@pubstack/common/src/snoozeAlarm'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const SNOOZE_ALARMS_QUERY_KEYS = ['snooze-alarms']
const url = '/admin/snooze-alarm'
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useSnoozeAlarms = () => {
  return useQuery<SnoozeAlarm[]>({
    url,
    keys: SNOOZE_ALARMS_QUERY_KEYS,
  })
}
//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateSnoozeAlarms = (toasts: MutationToasts = {}) => {
  return useMutation<Omit<SnoozeAlarm, 'id' | 'expirationTime'>>({
    method: 'post',
    url,
    collectionKeys: SNOOZE_ALARMS_QUERY_KEYS,
    ...toasts,
  })
}
export const useDeleteSnoozeAlarms = (id: string, toasts: MutationToasts = {}) => {
  return useMutation<void>({
    method: 'delete',
    url: `${url}/${id}`,
    collectionKeys: SNOOZE_ALARMS_QUERY_KEYS,
    resourceId: id,
    ...toasts,
  })
}
